import React, { useEffect } from 'react';
import { useLocation, Redirect } from 'react-router-dom';
import rollbar from '../utils/rollbar';
import mixpanel from '../utils/mixpanel';
import { DASH_BOARD_PATH } from '../constants/routes';
import useSearchParams from '../hooks/useSearchParams';
import { Typography, Box } from '@material-ui/core';

export const InvalidRoute = () => {
  const location = useLocation();
  const searchParams = useSearchParams();
  const hideNav = searchParams.hideNav === 'true';

  useEffect(() => {
    rollbar.warn(`A user tried to access an invalid route: ${location.pathname}`);
    mixpanel.track('Invalid Route Attempted', { path: location.pathname });
  }, [location]);

  // When iframed within Infohub, we don't want to redirect to the dashboard, as the user will be unable to search.
  // Instead, we'll just show a message.
  if (hideNav) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <Typography align="center" variant="h3">
          Page Not Found in Spotlight
        </Typography>
      </Box>
    );
  }

  return <Redirect to={{ pathname: DASH_BOARD_PATH, state: { invalidRoute: true } }} />;
};
